module.exports = __webpack_public_path__ + "img/perspectives-slide05.6ca45fd2.jpg";